interface UnreadBadgeProps {
  count: number;
  className?: string;
}

/**
 * Red unread counter used on conversation rows and on the "Chat echipă" entry
 * in the app sidebar. A fixed height with a matching minimum width keeps a
 * single digit inside a true circle; padding alone made it an oval because the
 * horizontal padding was wider than the vertical one. Two-digit counts widen
 * into a pill. Renders nothing at zero so callers don't have to guard.
 */
export function UnreadBadge({ count, className = '' }: UnreadBadgeProps) {
  if (count <= 0) return null;
  return (
    <span
      className={`inline-flex h-5 min-w-5 shrink-0 items-center justify-center rounded-full bg-red-500 px-1.5 text-xs font-semibold leading-none text-white ${className}`}
    >
      {count > 99 ? '99+' : count}
    </span>
  );
}
